var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "common-content",
    [
      _c("page-title", { attrs: { pageName: _vm.pro } }),
      _c("div", { staticClass: "engin-toggle" }, [
        _c(
          "ul",
          _vm._l(_vm.classList, function(item, index) {
            return _c("li", { key: item.id, staticClass: "engin-list" }, [
              _c(
                "button",
                {
                  class: { engin_line: index == _vm.idx },
                  on: {
                    click: function($event) {
                      return _vm.toggle(index)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
              )
            ])
          }),
          0
        )
      ]),
      _c("div", { staticClass: "engin-content" }, [
        _c(
          "ul",
          [
            _vm._l(_vm.res[0].imgList, function(item) {
              return _c("li", { key: item.id }, [
                _c("div", { staticClass: "imgcover" }),
                _c("img", { attrs: { src: item.url, alt: "" } })
              ])
            }),
            _c("div", { staticClass: "project-detail_text" }, [
              _c("hr"),
              _c("p", [_vm._v(_vm._s(_vm.res[0].content))])
            ])
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8543d6c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8543d6c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/curing/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8543d6c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/curing/index.vue
// module chunks = 14